import { useEffect } from 'react';

export const useMissingChunk = () => {
  useEffect(() => {
    const onScriptError = (e: ErrorEvent) => {
      const tgt = e.target as HTMLScriptElement | null;
      if (tgt?.src?.includes('/_next/')) {
        console.warn('[Next] detected missing script:', tgt.src);
        // Delay reload to allow other handlers (e.g., Sentry) to capture the error
        setTimeout(() => {
          window.location.reload();
        }, 0);
      }
    };

    const onPromiseRejection = (e: PromiseRejectionEvent) => {
      const msg = e.reason?.message || '';
      if (/Loading chunk [\w-]+ failed/.test(msg)) {
        console.warn('[Next] detected stale chunk:', msg);
        // Delay reload to allow other handlers (e.g., Sentry) to capture the error
        setTimeout(() => {
          window.location.reload();
        }, 0);
      }
    };

    window.addEventListener('error', onScriptError, true);
    window.addEventListener('unhandledrejection', onPromiseRejection);

    return () => {
      window.removeEventListener('error', onScriptError, true);
      window.removeEventListener('unhandledrejection', onPromiseRejection);
    };
  }, []);
};
